import React from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import MaskSelectorToolStyles from "../MaskSelectorToolStyles";
import { makeStyles } from "tss-react/mui";
import {
    font_size_h4,
    global_font_size,
    res_grey_800,
    res_grey_900,
} from "ui-common/components/design-tokens";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles()(() => ({
    header: {
        fontSize: font_size_h4,
        fontColor: res_grey_900,
    },
    subHeader: {
        fontSize: global_font_size,
        fontColor: res_grey_800,
    },
    button: {
        width: "82px",
        height: "40px",
        fontSize: "13px"
    },
    buttonContainer: {
        display: 'flex',
        gap: '10px'
    }
}));

const QuitScanDialog = ({ open, onClose, onQuit }) => {
    const { classes: commonClasses } = MaskSelectorToolStyles();
    const { t } = useTranslation("pages.MaskSelector.nextGenScan.QuitScanDialog");

    const mainMessage = t("mainMessage");
    const description = t("description");
    const closePopupButton = t("closePopupButton");
    const cancelButton = t("cancelButton");

    const { classes: localClasses } = useStyles();

    return (
        <Dialog open={open}
                // 👇 Props passed to Paper (modal content)
                PaperProps={{ sx: { borderRadius: "6px" } }}
        >
            <Box maxWidth="335px" sx={{padding: "24px"}}>
                <Box>
                    <Box>
                        <Typography
                            className={`${commonClasses.noOutline} ${localClasses.header}`}
                            tabIndex="0"
                            aria-label={mainMessage}
                            pb={1.5}
                        >
                            {mainMessage}
                        </Typography>
                        <Typography
                            className={`${commonClasses.noOutline} ${localClasses.subHeader}`}
                            tabIndex="0"
                            aria-label={mainMessage}
                        >
                            {description}
                        </Typography>
                    </Box>
                    <Box className={`${localClasses.buttonContainer}`} mt="32px">
                        <Button
                            disableRipple
                            variant="contained"
                            color="primary"
                            onClick={onClose}
                            className={`${localClasses.button}`}
                        >
                            {cancelButton}
                        </Button>
                        <Button
                            disableRipple
                            variant="outlined"
                            color="secondary"
                            onClick={onQuit}
                            className={`${localClasses.button}`}
                        >
                            {closePopupButton}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
};

export default QuitScanDialog;
